/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sonstigefaechertmp2Inputs */

const de__field_sonstigefaechertmp2 = /** @type {(inputs: _Field_Sonstigefaechertmp2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige Fächer`)
};

/**

* @param {_Field_Sonstigefaechertmp2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sonstigefaechertmp2 = /** @type {((inputs?: _Field_Sonstigefaechertmp2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sonstigefaechertmp2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_sonstigefaechertmp2(inputs)
});
export { _field_sonstigefaechertmp2 as "_field_sonstigeFaecherTmp" }